module.exports = __webpack_public_path__ + "img/company_inc-date.b69377df.svg";